import { Card, Col, Row, Spin, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from 'services/apiClient';

const { Text } = Typography;

type LegalNotificationSummary = {
  inspector: number;
  company: number;
  central: number;
  totalLegalNotification: number;
};

const emptySummary: LegalNotificationSummary = {
  inspector: 0,
  company: 0,
  central: 0,
  totalLegalNotification: 0,
};

const LegalNotificationSummaryCard = () => {
  const [summary, setSummary] = useState<LegalNotificationSummary>(emptySummary);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadSummary = async () => {
      setIsLoading(true);
      try {
        const response = await apiFetch('/proposals/report/legal-notification-summary');
        setSummary({
          inspector: Number(response?.inspector ?? 0),
          company: Number(response?.company ?? 0),
          central: Number(response?.central ?? 0),
          totalLegalNotification: Number(response?.totalLegalNotification ?? 0),
        });
      } catch (error) {
        console.error('Dashboard legal notification summary fetch failed', error);
        setSummary(emptySummary);
      } finally {
        setIsLoading(false);
      }
    };

    loadSummary();
  }, []);

  const items = [
    { key: 'company', label: 'Firma', value: summary.company },
    { key: 'inspector', label: 'PKM Uzmanı', value: summary.inspector },
    { key: 'central', label: 'Merkez', value: summary.central },
  ];

  return (
    <Card
      bordered={false}
      style={{
        background: '#fff',
        borderRadius: 8,
        width: '100%',
      }}
      bodyStyle={{ padding: 20 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 18, color: '#333', fontWeight: 700 }}>Yasal Bildirim Takibi</div>
          <Text type="secondary">Yasal Bildirim Statüsündeki Projeler</Text>
        </div>
        <div style={{ color: summary.totalLegalNotification === 0 ? '#52c41a' : '#f5222d', fontWeight: 700, fontSize: 28 }}>
          {isLoading ? <Spin size="small" /> : summary.totalLegalNotification}
        </div>
      </div>

      <Row gutter={[16, 16]}>
        {items.map((item) => (
          <Col key={item.key} xs={24} md={8}>
            <Link to="/project-followup?tab=3" style={{ display: 'block', width: '100%' }}>
              <div
                className="dashboard-card-clickable"
                style={{
                  background: '#f7f8fb',
                  borderRadius: 8,
                  minHeight: 92,
                  padding: 16,
                }}
              >
                <div style={{     borderLeft: `3px solid ${item.value === 0 ? '#52c41a' : '#f5222d'}`,
 paddingLeft: 12 }}>
                  <div style={{ color: '#8c8c8c', fontSize: 13, minHeight: 22 }}>{item.label}</div>
                  <div style={{ color: item.value === 0 ? '#52c41a' : '#f5222d', fontSize: 24, fontWeight: 700 }}>
                    {isLoading ? <Spin size="small" /> : item.value}
                  </div>
                </div>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default LegalNotificationSummaryCard;
